
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as JoinClassIconComponent } from "./join-class-icon.svg";

export const JoinClassIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <JoinClassIconComponent {...props} />;
};
